import api from '../../../../App/socket';

export const createUserEmail = (user_id, name, email) => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'NestedCreate',
        options: {
            create: { name, email },
            where: {
                _id: user_id,
            },
            fullPath: 'person.emails',
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_emails_requests/create_user_email_request.js